<script lang="ts">
import { classname } from '@/js/utils.js';

const classBaseTextarea = classname('vue-base-textarea');
export default {
  name: 'BaseTextarea',
  props: {
    placeholder: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      modelValue: this.value,
    };
  },
  methods: {
    classBaseTextarea,
    emitTextarea() {
      this.$emit('update:modelValue', this.modelValue);
    },
  },
};
</script>

<template>
  <textarea
    v-model="modelValue"
    :placeholder="placeholder"
    rows="2"
    :class="classBaseTextarea()"
    @input="emitTextarea"
  />
</template>

<style lang="scss">
.vue-base-textarea {
  box-sizing: border-box;
  width: 100%;
  padding: 23px 16px;
  font-size: 18px;
  font-family: inherit;
  border: 1px solid #c4c4c4;
  border-radius: 2px;
  resize: none;

  &::placeholder {
    color: #c4c4c4;
  }

  &:not(:read-only, .error) {
    &:hover,
    &:focus {
      border-color: #000;
    }
  }
}
</style>
